import * as React from "react";
import { Layout as LayoutAntd, Row, Col, Dropdown, Menu, Button } from "antd";
import { Avatar, MainMenu, Footer } from "../../components";
import { Link } from "react-router-dom";
//import { PrequestLogo } from "src";
import { ReactComponent as PrequestLogo } from "../../media/PrequestLogo.svg";
// import PrequestLogo from '../../media/PrequestLogo.svg';
import { useTranslation } from "react-i18next";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// actions
// styles
import "./Layout.less";
import { useDispatch, useSelector } from "react-redux";
// actions
import { menuToggle } from "../../redux/main/mainActions";

type LayoutProps = {
  userName?: string;
  userNameCap?: string;
  menuMargin?: "256px" | string;
  menuMarginCollapsed?: "80px" | string;
  hideFooter?: boolean;
  topBarChildren?: React.ReactNode;
  linkProfile?: string;
  linkLogout?: string;
  children?: React.ReactNode;
  profileLink?: string;
  homeLink?: string;
  logout?: React.MouseEventHandler;
  menu?: React.ReactNode;
};

export default function LayoutContainer({
  menuMargin: propsMenuMargin = "256px",
  menuMarginCollapsed: propsMenuMarginCollapsed = "80px",
  hideFooter: propsHideFooter = false,
  topBarChildren: propsTopbarChildren,
  children: propsChildren,
  userName: propsUserName,
  userNameCap: propsUserNameCap,
  profileLink: propsProfileLink,
  homeLink: propsHomeLink,
  logout: propsLogout,
  menu: propsMenu,
}: React.PropsWithChildren<LayoutProps>) {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const toggleMenu = React.useCallback(
    () => dispatch(menuToggle()),
    [dispatch]
  );
  const menuIsCollapsed = useSelector((state: any) => state.main.menuIsCollapsed);

  const _menuMargin = propsMenuMargin;
  const _menuMarginCollapsed = propsMenuMarginCollapsed;

  const style = {
    marginLeft: menuIsCollapsed ? _menuMarginCollapsed : _menuMargin,
    transition: "all 0.2s",
  };

  const ProfileMenu = (
    <Menu>
      <Menu.Item>
        <Link to={propsProfileLink}>
          {/* <FontAwesomeIcon icon={["fal", "user"]} /> */}
          <span className="page-menuitem-dropdown">
            {t("menuitems.profile")}
          </span>
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Button type="text" onClick={propsLogout}>
          {t("menuitems.logout")}
        </Button>
      </Menu.Item>
    </Menu>
  );

  return (
    <LayoutAntd className="page">
      {/* Left side menu */}
      <LayoutAntd.Sider
        className="main-navigation"
        collapsible
        collapsed={menuIsCollapsed}
        collapsedWidth={80}
        onCollapse={toggleMenu}
        width={256}
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
        }}
      >
        <div className="sider_logo_container">
          <Link to={propsHomeLink}>
            <PrequestLogo className="client-logo-sider" />
          </Link>
        </div>
        {propsMenu}
      </LayoutAntd.Sider>
      {/* Left side menu end*/}

      <LayoutAntd
        className="page-content"
        style={{
          ...style,
          overflow: "initial",
          width: "calc(100% - " + style.marginLeft + ")",
        }}
      >
        <LayoutAntd.Header
          className="page-header"
          style={{
            position: "fixed",
            zIndex: 20,
            width: "calc(100% - " + style.marginLeft + ")",
            transition: style.transition,
            right: 0,
          }}
        >
          <Row justify="space-between">
            <Col>{propsTopbarChildren ? propsTopbarChildren : null}</Col>
            <Col className="page-header-topright">
              <Dropdown
                overlay={ProfileMenu}
                placement="bottomRight"
                trigger={["click"]}
              >
                <div className="page-header-dropdown">
                  {/* FIX DEFAULT TYPESCRIPT! */}
                  <Avatar name={propsUserName} />
                  <span className="page-header-username">
                    {propsUserNameCap || t("menuitems.profile")}
                  </span>
                </div>
              </Dropdown>
            </Col>
          </Row>
        </LayoutAntd.Header>
        {/* Header content positioning fix */}
        <LayoutAntd.Header className="header-content-fix" />
        {/* End */}

        {propsChildren}

        {/* Footer */}
        {!propsHideFooter ? (
          <LayoutAntd.Footer style={{ margin: 0, padding: 0 }}>
            <Footer />
          </LayoutAntd.Footer>
        ) : null}
        {/* Footer end */}
      </LayoutAntd>
    </LayoutAntd>
  );
}
